import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "value"]
const _hoisted_2 = ["for"]

import { onMounted, onUnmounted, ref } from "vue";
import { isClickInsideElement } from "@sazka/utils/click-inside-element";
import { TicketsSortingOption } from "@/tickets/utils/tickets-sorting-option-enum";


export default /*@__PURE__*/_defineComponent({
  __name: 'tickets-filter-sort-menu',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["closeMenu"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const selectedSorting = _useModel<TicketsSortingOption>(__props, "modelValue");

const emit = __emit;

const sortingMenuElement = ref<HTMLDivElement>();

function getSortingButtonText(clickedSort: TicketsSortingOption) {
    switch (clickedSort) {
        case TicketsSortingOption.Default:
            return "Doporučené";
        case TicketsSortingOption.PriceAscending:
            return "Od nejlevnějšího losu";
        case TicketsSortingOption.PriceDescending:
            return "Od nejdražšího losu";
        case TicketsSortingOption.WinAscending:
            return "Od nejmenší výhry";
        case TicketsSortingOption.WinDescending:
            return "Od největší výhry";
    }
}

function handleEscPress(event: KeyboardEvent) {
    if (event.key === "Escape") {
        emit("closeMenu");
    }
}

function handleClickOutside({ clientX, clientY }) {
    if (!isClickInsideElement(sortingMenuElement.value, { x: clientX, y: clientY })) {
        emit("closeMenu");
    }
}

onMounted(() => {
    window.addEventListener("keydown", handleEscPress);

    // This timeout is necessary so that the event listener is added only after the component is fully loaded
    setTimeout(() => {
        window.addEventListener("click", handleClickOutside);
    }, 0);
});

onUnmounted(() => {
    window.removeEventListener("keydown", handleEscPress);
    window.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tickets-filter__breadcrumbs",
    ref_key: "sortingMenuElement",
    ref: sortingMenuElement
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TicketsSortingOption), (sortingOption) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: sortingOption }, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          id: sortingOption,
          value: sortingOption,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSorting).value = $event))
        }, null, 8, _hoisted_1), [
          [_vModelRadio, selectedSorting.value]
        ]),
        _createElementVNode("label", {
          for: sortingOption,
          class: _normalizeClass([
                    { 'tickets-filter__breadcrumb--active': selectedSorting.value === sortingOption },
                    'tickets-filter__breadcrumb',
                ])
        }, _toDisplayString(getSortingButtonText(sortingOption)), 11, _hoisted_2)
      ], 64))
    }), 128))
  ], 512))
}
}

})